import { render, staticRenderFns } from "./planSelector.vue?vue&type=template&id=2fdb4f91&scoped=true"
import script from "./planSelector.vue?vue&type=script&lang=js"
export * from "./planSelector.vue?vue&type=script&lang=js"
import style0 from "./planSelector.vue?vue&type=style&index=0&id=2fdb4f91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb4f91",
  null
  
)

export default component.exports